import { useState } from 'react';
import { ApplyArtePlaceholder } from './v3/ApplyArtePlaceholder';
import { EditMoldePage } from './v3/EditMoldePage';
import { Hub } from './v3/Hub';

type MoldeOneFlow = 'hub' | 'editar-molde' | 'aplicar-arte';

export function MoldeOnePage() {
  const [flow, setFlow] = useState<MoldeOneFlow>('hub');

  return (
    <div className="flex h-full flex-col bg-navy-950 text-white">
      {flow === 'hub' && <Hub onSelect={(nextFlow) => setFlow(nextFlow)} />}
      {flow === 'editar-molde' && <EditMoldePage onBack={() => setFlow('hub')} />}
      {flow === 'aplicar-arte' && <ApplyArtePlaceholder onBack={() => setFlow('hub')} />}
    </div>
  );
}
